<!-- Desktop -->

<header class="header" *ngIf="!env.isMobile">
    <div class="container-fluid">
        <div class="row">
            <div class="header-top col-md-12">
                <div class="float-left"><a href="javascript:void(0)" [routerLink]="['/home']"
                        class="logo router-link-exact-active router-link-active">
                        <img src="assets/img/{{env.host.name}}/logo.png" class="logo-icon"></a>
                </div>
                <ul class="float-right d-flex align-items-center">
                    <li class="btns__deposit_withdrawal" *ngIf="depoWithdrawCondition()">
                         <a href="javascript:void();" routerLink="/deposit" class="btn_deposit">
                           <img src="https://speedcdn.io/assets/diamond-client-v8/deposit-icon.webp" class="img-fluid"> deposit
                         </a>
                         <a href="javascript:void();" routerLink="/withdraw" class="btn_withdrawal">
                           <img src="https://speedcdn.io/assets/diamond-client-v8/withdrawal-icon.webp" class="img-fluid"> withdrawal
                         </a>
                     </li>
                    <li class="search float-left">
                        <input name="game_keyword" placeholder="All Events" autocomplete="off" type="text"
                            [ngClass]="{'search-input-show' : searchStatus}" [(ngModel)]="selected"
                            [ngModelOptions]="{standalone: true}" [typeahead]="searchData"
                            [optionsListTemplate]="customItemTemplate" [typeaheadScrollable]="true"
                            typeaheadOptionField="name" (typeaheadOnSelect)="redirectDetail($event)">

                        <ng-template #customItemTemplate let-matches="matches" let-query="query"
                            let-typeaheadTemplateMethods>
                            <ul class="custom-list-group search-game-ul">
                                <li *ngFor="let match of matches"
                                    [class.active]="typeaheadTemplateMethods.isActive(match)">
                                    <a href="javascript:void(0)">
                                        <div>
                                            <a href="javascript:void(0)"
                                                routerLink="/game-detail/{{match?.item?.event_id}}" class="">
                                                <div class="search-game-name">
                                                    <b>{{eventTypesObj[match?.item?.event_type_id]}}</b> <b></b>
                                                </div>
                                                <div class="game-date text-right" *ngIf="match?.item.open_date_format">
                                                    {{match?.item.open_date_format | date : 'dd/MM/YYYY HH:mm:ss'}}
                                                </div>
                                                <div class="game-date text-right" *ngIf="!match?.item.open_date_format">
                                                    {{match?.item?.market_start_time_format | date : 'dd/MM/YYYY
                                                    HH:mm:ss'}}</div>
                                                <div class="game-teams">{{match?.item?.name}}</div>
                                            </a>
                                        </div>
                                    </a>
                                </li>
                            </ul>

                            <!-- <a href="javascript:void(0);" id="menu-link-redi"
                              routerLink="/game-detail/{{model.event_id}}" class="searchAnchor">
                              {{model.name}}
                          </a> -->
                        </ng-template>
                        <a href="javascript:void(0)" (click)="searchStatus = !searchStatus;"><i
                                class="fas fa-search-plus"></i></a>
                        <!---->
                    </li>
                    <li class="float-left download-apklink">
                        <div><a href="javascript:void(0)" class="rules-link m-r-5"
                                [routerLink]="['/rules']"><b>Rules</b></a></div>
                    </li>
                    <li class="ballance float-left" *ngIf="isLogin()">
                        <div><span>Balance: </span> <b><span>{{fixedPostDecimal(userData?.available_balance)}}</span></b></div>
                        <div><a href="javascript:void(0)" (click)="openModal(marketAnalysisModal)"><span
                                    class="t-underline">Exposure: </span> <b><span
                                        class="t-underline" [ngClass]="userData?.expose >= 0 ? 'text-greenn' : 'text-redd'">{{fixedPostDecimal(userData?.expose)}}</span></b></a>
                        </div>
                    </li>
                    <li class="account float-left" *ngIf="isLogin()">
                        <span>
                            {{userData?.username}}
                            <i class="fas fa-chevron-down"></i></span>
                            
                            <ul>
                                <div class="balance-information" *ngIf="userData?.wager_active == 1">
                                <div class="balance-row">
                                    <div class="balance-text-left">Wallet Amount <small>(Inclusive bonus)</small></div>
                                    <div class="balance-price">{{balInfo.wall_amt}}</div>
                                </div>
                                <div class="balance-row">
                                    <div class="balance-text-left">Net Exposure</div>
                                    <div class="balance-price">{{balInfo.net_expo}}</div>
                                </div>
                                <div class="balance-row">
                                    <div class="balance-text-left">Bonus</div>
                                    <div class="balance-price">{{balInfo.bonus}}</div>
                                </div>
                                <div class="balance-row">
                                    <div class="balance-text-left">Available Withdrawal</div>
                                    <div class="balance-price">{{balInfo.avail_withdrawal}}</div>
                                </div>
                              </div>
                              <div class="ab_rae_btns" *ngIf="userData?.wager_active == 1">
                                <li><a href="javascript:void(0)" [routerLink]="['/reffer-and-earn']" class="rae_btns">Refer and Earn</a></li>
                                <li><a href="javascript:void(0)" [routerLink]="['/bonus-list']" class="ab_btns">Awaiting Bonus <span>{{balInfo.await_bonus}}</span></a></li>
                              </div>
                              <li *ngIf="userData?.wager_active == 1"><a href="javascript:void(0)" (click)="openBonusRule()" class="">Bonus Rule</a></li>
                            <li><a href="javascript:void(0)" [routerLink]="['/reports/account-statement']"
                                    class="">Account
                                    Statement</a></li>
                            <li><a href="javascript:void(0)" [routerLink]="['/reports/profit-loss']" class="">Profit
                                    Loss Report</a>
                            </li>
                            <li><a href="javascript:void(0)" [routerLink]="['/reports/unsettled-bets']"
                                    class="">Unsetteled Bet</a>
                            </li>
                            <!-- <li><a href="javascript:void(0)" [routerLink]="['/reports/sport-summary-report']" class="">Sport Smmary</a></li> -->
                            <li><a href="javascript:void(0)" [routerLink]="['/change-btn-value']" class="">Set Button
                                    Values</a></li>
                            <li><a href="javascript:void(0)" [routerLink]="['/change-password']" class="">Change
                                    Password</a></li>
                            <!-- <li><a href="javascript:void(0)" [routerLink]="['/rules']" class="">Rule</a></li> -->
                            <li>
                                <hr>
                            </li>
                            <li><a href="javascript:void(0)" (click)="logOut()">signout</a></li>
                        </ul>
                    </li>
                    <li *ngIf="!isLogin()">
                        <div class="ml-3">
                            <a *ngIf="env.host.signUpActive" href="javascript:void(0)" class="auth-link m-r-5"
                                (click)="openSignUpModal()"><b>Signup</b></a>
                            <a href="javascript:void(0)" class="auth-link m-r-5"
                                (click)="_common.openLogin()"><b>Login</b></a>
                        </div>
                    </li>
                </ul>
                <app-upcoming></app-upcoming>
            </div>
            <div class="header-bottom m-t-10 col-md-12">
                <nav class="navbar navbar-expand-md btco-hover-menu">
                    <button type="button" data-toggle="collapse" data-target="#navbarNavDropdown"
                        aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation"
                        class="navbar-toggler"><span class="navbar-toggler-icon"></span></button>
                    <div class="collapse navbar-collapse">
                        <ul class="list-unstyled navbar-nav">
                            <li class="nav-item"><a href="javascript:void(0)" [routerLink]="['/home']"
                                    routerLinkActive="router-link-exact-active router-link-active"><b>Home</b></a></li>
                            <!-- <li class="nav-item new-launch-text"><a href="javascript:void(0)" [routerLink]="['/game-detail/28127348']" routerLinkActive="router-link-exact-active router-link-active"><b>IPL - CUP WINNER</b></a></li> -->
                            <!-- <li class="nav-item new-launch-text"><a href="javascript:void(0)" [routerLink]="['/game-detail/27996014']" routerLinkActive="router-link-exact-active router-link-active"><b>BIG BASH</b></a></li> -->
                            <li class="nav-item" *ngFor="let mn of menu; let i=index;trackBy:trackByIndex;">
                                <a href="javascript:void(0)" *ngIf="mn?.id != '99991'"
                                    [ngClass]="{'new-tag-menus': (events.binary.includes(mn?.id) || events.sportsBook.includes(mn.id))}"
                                    [routerLink]="events.casino.includes(mn.id) ? ['/casino', mn.id] : events.sportsBook.includes(mn.id) ? ['/sports-book'] : ['/game-list', mn.id]"
                                    routerLinkActive="router-link-exact-active router-link-active">
                                    <!-- <b>{{eventsName[mn.id] ? eventsName[mn.id] : mn.name}}</b> <em>New</em> -->
                                    <b>{{mn.name}}</b>
                                </a>
                                <!-- <a href="javascript:void(0)" *ngIf="mn?.id == '99991'" [ngClass]="{'new-tag-menus': (events.sportsBook.includes(mn.id))}" (click)="confirmBoxSportBook(mn.id)" routerLinkActive="router-link-exact-active router-link-active"><b>{{eventsName[mn.id] ? eventsName[mn.id] : mn.name}}</b> <em>New</em></a> -->
                            </li>
                            <li class="nav-item new-launch-text"><a href="javascript:void(0)"
                                    [routerLink]="['/game-multi-market']"
                                    routerLinkActive="router-link-exact-active router-link-active"><b>Multi
                                        Market</b></a></li>
                        </ul>
                    </div>
                </nav>
            </div>
        </div>
    </div>
    <div>
    </div>
    <div class="modal-market">
    </div>
</header>
<!-- Desktop -->


<!-- Mobile -->
<header class="header" *ngIf="env.isMobile">

    <!-- download app div -->
    <div class="app-download-div" *ngIf="isLogin() && env.host.downloadApk != '' && downloadDivStatus">
        <img src="https://cdn-icons-png.flaticon.com/512/300/300218.png">
        <h5>download our app <span>instant download on your deivce</span></h5>
        <a [href]="env.host.downloadApk" target="_blank">install</a>
        <i class="fas fa-window-close" (click)="hideDwnApk()"></i>
    </div>
    <!-- download app div end -->
    <div class="container-fluid">
        <div class="row row5 pt-1 pb-1">
            <div class="logo col-6">
                <a href="javascript:void(0)" (click)="redirectHome()" [routerLink]="['/m/home']"
                    class="router-link-exact-active router-link-active">
                    <i class="fas fa-home mr-1"></i>
                    <img src="assets/img/{{env.host.name}}/logo.png" alt="Exchange" class="img-fluid logo"></a>
            </div>
            <div class="col-6 text-right bal-expo" *ngIf="isLogin()">
                <p class="mb-0">
                  <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3 21.0001H21M4 18.0001H20M6 18.0001V13.0001M10 18.0001V13.0001M14 18.0001V13.0001M18 18.0001V13.0001M12 7.00695L12.0074 7.00022M21 10.0001L14.126 3.88986C13.3737 3.2212 12.9976 2.88688 12.5732 2.75991C12.1992 2.64806 11.8008 2.64806 11.4268 2.75991C11.0024 2.88688 10.6263 3.2212 9.87404 3.88986L3 10.0001H21Z" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  <b>{{fixedPostDecimal(userData?.available_balance)}}</b>
                </p>
                <div class="">
                    <span class="mr-1" (click)="openModal(marketAnalysisModal)"><u>Exp: <span [ngClass]="userData?.expose >= 0 ? 'text-greenn' : 'text-redd'">{{fixedPostDecimal(userData?.expose)}}</span></u></span>
                    <div class="dropdown d-inline-block">
                        <a href="javascript:void(0)" data-bs-toggle="dropdown" class="dropdown-toggle"
                            aria-expanded="false"><u data-v-3f4cf84d="">{{userData?.username}}</u></a>
                        <div class="dropdown-menu">

                            <div class="balance-information" *ngIf="userData?.wager_active == 1">
                                <div class="balance-row">
                                    <div class="balance-text-left">Wallet Amount <small>(Inclusive bonus)</small></div>
                                    <div class="balance-price">{{balInfo.wall_amt}}</div>
                                </div>
                                <div class="balance-row">
                                    <div class="balance-text-left">Net Exposure</div>
                                    <div class="balance-price">{{balInfo.net_expo}}</div>
                                </div>
                                <div class="balance-row">
                                    <div class="balance-text-left">Bonus</div>
                                    <div class="balance-price">{{balInfo.bonus}}</div>
                                </div>
                                <div class="balance-row">
                                    <div class="balance-text-left">Available Withdrawal</div>
                                    <div class="balance-price">{{balInfo.avail_withdrawal}}</div>
                                </div>
                            </div>
                            <div class="ab_rae_btns" *ngIf="userData?.wager_active == 1">
                              <a href="javascript:void(0)" [routerLink]="['/reffer-and-earn']" class="dropdown-item ab_btns">Refer and Earn</a>
                              <a href="javascript:void(0)" [routerLink]="['/bonus-list']" class="dropdown-item rae_btns">Awaiting Bonus <span>{{balInfo.await_bonus}}</span></a>
                            </div>
                            <a href="javascript:void(0)" (click)="redirectHome()" [routerLink]="['/m/home']"
                                class="dropdown-item router-link-exact-active router-link-active">Home</a>
                            <a href="javascript:void(0)" [routerLink]="['/m/game-multi-market']"
                                class="dropdown-item router-link-exact-active router-link-active">Multi Market</a>
                            <a href="javascript:void(0)" [routerLink]="['/m/reports/account-statement']"
                                class="dropdown-item">Account
                                Statement</a>
                            <a href="javascript:void(0)" [routerLink]="['/m/reports/profit-loss']"
                                class="dropdown-item">Profit Loss
                                Report</a>
                            <!-- <a href="javascript:void(0)" [routerLink]="['/m/reports/bet-history']" class="dropdown-item">Bet History</a> -->
                            <a href="javascript:void(0)" [routerLink]="['/m/reports/unsettled-bets']"
                                class="dropdown-item">Unsetteled
                                Bet</a>
                            <!-- <a href="javascript:void(0)" [routerLink]="['/m/reports/sport-summary-report']" class="dropdown-item">Sport Smmary</a> -->
                            <a href="javascript:void(0)" [routerLink]="['/m/change-btn-value']"
                                class="dropdown-item">Set Button
                                Values</a>
                            <a href="javascript:void(0)" [routerLink]="['/m/change-password']"
                                class="dropdown-item">Change
                                Password</a>
                            <a href="javascript:void(0)" [routerLink]="['/m/rules']" class="dropdown-item">Rules</a>
                            <!--  <a href="rules.php" class="dropdown-item">Rules</a>  -->
                            <a href="javascript:void(0)" (click)="logOut()"
                                class="dropdown-item mt-2 text-danger"><b>Logout</b></a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-6 text-right" *ngIf="!isLogin()">
                <div class="auth-mob">
                    <a *ngIf="env.host.signUpActive" href="javascript:void(0)" class="auth-link m-r-5"
                        (click)="openSignUpModal()"><b>Signup</b></a>
                    <a href="javascript:void(0)" class="auth-link m-r-5" (click)="_common.openLogin()"><b>Login</b></a>
                </div>
            </div>
        </div>

        <div class="btns__deposit_withdrawal" *ngIf="depoWithdrawCondition()">
            <a href="javascript:void();" routerLink="/m/deposit" class="btn_deposit">
              <img src="https://speedcdn.io/assets/diamond-client-v8/deposit-icon.webp" class="img-fluid"> deposit
            </a>
            <a href="javascript:void();" routerLink="/m/withdraw" class="btn_withdrawal">
              <img src="https://speedcdn.io/assets/diamond-client-v8/withdrawal-icon.webp" class="img-fluid"> withdrawal
            </a>
           <div class="social_links d-flex align-items-center" *ngIf="env.host.social.isShow">
             <!-- <a class="social_inner_link" *ngIf="env.host.social.fbLink != ''" [href]="env.host.social.fbLink" target="_blank">
               <img class="img-fluid" src="https://cdn-icons-png.flaticon.com/512/2504/2504903.png">
             </a> -->
             <a class="social_inner_link" *ngIf="env.host.social.tel2Link != ''" [href]="env.host.social.tel2Link" target="_blank">
               <img class="img-fluid" src="https://cdn-icons-png.flaticon.com/512/2504/2504941.png">
             </a>
           </div>
        </div>
        <!-- <div class="row header-deposit" *ngIf="userData && userData?.branch_panel_active == 1">
            <div class="col deposit"> <a routerLink="/m/deposit"> <img src="assets/img/deposit.png"> Deposit</a></div>
            <div class="col withdraw"><a routerLink="/m/withdraw"> <img src="assets/img/withdraw.png"> Withdraw</a>
            </div>
        </div> -->

        <div class="row row5 header-bottom">
            <div class="col-12">
                <div class="search-box-container">
                    <div class="search-box float-left ">
                        <input type="text" class="search_input" [ngClass]="{'search_input-hover' : searchStatus}"
                            [(ngModel)]="selected" [ngModelOptions]="{standalone: true}" [typeahead]="searchData"
                            [optionsListTemplate]="customItemTemplate1" [typeaheadScrollable]="true"
                            [typeaheadOptionsInScrollableView]="5" typeaheadOptionField="name"
                            (typeaheadOnSelect)="redirectDetail($event)">

                        <ng-template class="mo_type_search" #customItemTemplate1 let-matches="matches" let-query="query"
                            let-typeaheadTemplateMethods>
                            <ul>
                                <li *ngFor="let match of matches"
                                    [class.active]="typeaheadTemplateMethods.isActive(match)">
                                    <a href="javascript:void(0)" routerLink="/m/game-detail/{{match?.item?.event_id}}"
                                        class="">
                                        <div>
                                            <div class="search-game-name">
                                                <b>{{eventTypesObj[match?.item?.event_type_id]}}</b> <b></b>
                                            </div>
                                            <div class="game-date text-right" *ngIf="match?.item.open_date_format">
                                                {{match?.item.open_date_format | date : 'dd/MM/YYYY HH:mm:ss'}}</div>
                                            <div class="game-date text-right" *ngIf="!match?.item.open_date_format">
                                                {{match?.item?.market_start_time_format | date : 'dd/MM/YYYY HH:mm:ss'}}
                                            </div>
                                            <div class="game-teams">{{match?.item?.name}}</div>
                                        </div>
                                    </a>
                                </li>
                            </ul>
                        </ng-template>
                        <a href="javascript:void(0)" class="search_icon" (click)="searchStatus = !searchStatus;">
                            <i class="fas" [ngClass]="searchStatus ? 'fa-times' : 'fa-search'"></i></a>
                    </div>
                    <div class="search-col d-none">
                        <form action="">
                            <input text="search">

                            <i class="fa fa-search"></i>
                        </form>
                    </div>
                </div>
                <app-upcoming></app-upcoming>
            </div>
        </div>

        <app-featured-events
            *ngIf="router.url.includes('home') || router.url.includes('slot') || router.url.includes('others') || router.url.includes('sports')"></app-featured-events>

        <!-- <div class="row header-b-menu"> -->
        <!-- <div class="col ipl">
          <a href="javasript:void(0)" routerLink="/m/game-detail/27996014" class="text-link">BIG BASH</a>
        </div> -->
        <!-- <div class="col election">
          <a href="javasript:void(0)" routerLink="/m/game-detail/28127348" class="text-link">IPL - CUP WINNER</a>
        </div> -->

        <!-- </div> -->
    </div>
</header>
<!-- Mobile -->



<!-- afterLoginModal -->

<div class="modal fade" bsModal #afterLoginModal="bs-modal" [config]="{ show: openafterLoginModal }" tabindex="-1"
 role="dialog" aria-labelledby="dialog-static-name">
 <div class="modal-dialog modal-dialog-centered modal-md modal-lr">
   <div class="modal-content">
     <!-- <div class="modal-header">
       <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="afterLoginModal.hide()">
         <i class="fa fa-close-thick"></i>
       </button>
     </div> -->
     <div class="modal-body p-0">
        <button style="position: absolute;right: 13px;top: 1px;color: #fff;font-size: 21px;" type="button" class="close" data-bs-dismiss="modal" aria-label="Close"
            (click)="afterLoginModal.hide()">
            <span aria-hidden="true">&times;</span>
        </button>
        <a href="javascript:void(0);" target="_blank" (click)="afterLoginModal.hide()">
            <!-- <img style="width: 100%;" [src]="env.host.afterLoginNoticePath" > -->
            <img class="img-fluid" src="https://speedcdn.io/assets/diamond-client-v8/popup.jpg">
        </a>
       <!-- <div style="box-shadow: 0px 0px 5px; padding: 10px;">
         <h2>Dear Client,</h2>
         <h5 class="mb-1">
           You are requested to login with our official site
             <a href="https://{{env?.host?.domain}}{{env?.host?.ext}}" target="_blank">'{{env?.host?.domain}}{{env?.host?.ext}}'</a>
              only. Please check the site name before you login.
           
         </h5>
         <h5 class="mb-1">Thanks for your support.</h5>
         <h5 class="mb-1">Team {{env?.host?.dName}}</h5>
     </div>
     <div class="mt-lg-5 mt-3 font-hindi" style="box-shadow: 0px 0px 5px; padding: 10px;">
         <h2>प्रिय ग्राहक,</h2>
         <h5 class="mb-1">
           आपसे अनुरोध है कि केवल हमारी आधिकारिक साइट
             <a href="https://{{env?.host?.domain}}{{env?.host?.ext}}" target="_blank">'{{env?.host?.domain}}{{env?.host?.ext}}'</a>
             से लॉगिन करें। लॉगइन करने से पहले साइट का नाम जरूर देख लें।
         </h5>
         <h5 class="mb-1">आपके समर्थन के लिए धन्यवाद।</h5>
         <h5 class="mb-1">टीम {{env?.host?.dName}}</h5>
     </div>
     <div class="text-right mt-3"><button class="btn btn-primary" style="min-width: 100px;" (click)="afterLoginModal.hide()">OK</button></div> -->
     </div>
   </div>
 </div>
</div>
<!-- /afterLoginModal -->

<!-- Market Analysis -->

<ng-template #marketAnalysisModal>
    <div class="modal-header">
        <h4 class="modal-title pull-left">My Market</h4>
        <button type="button" class="close btn-close pull-right" aria-label="Close" (click)="modalRef?.hide()">
            <span aria-hidden="true" class="visually-hidden">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <app-market-analysis (closeModal)="modalRef?.hide()"></app-market-analysis>
    </div>
</ng-template>
<!-- /Market Analysis -->

<div class="bottom_wplink" *ngIf="wpLink != ''">
    <a *ngIf="(env.wpLinkShowPages.includes(router.url.split('/')[1]))" [href]="wpLink">
        <img src="assets/img/wp_support.png" class="img-fluid">
    </a>
</div>
<!-- <div class="bottom_wplink" *ngIf="env.host.wpLink !='' && isLogin">
    <a *ngIf="(env.wpLinkShowPages.includes(router.url.split('/')[1]))" [href]="env.host.wpLink">
        <img src="assets/img/wp_support.png" class="img-fluid">
    </a>
</div> -->